import {LANDING_PATHS} from '../const/landingPaths';

export type Path = keyof typeof LANDING_PATHS['PL'];

export const getLandingPath = (lang: 'PL' | 'EN', path: Path) =>
    LANDING_PATHS[lang][path];
